import type { ICard } from "../../cardsSlice";

export const major4Card: ICard = {
    id: "major_4",
    arcana: "major",
    number: 4,
    suit: "major",
    court: "major",
    name: "Император",
    nameEn: "The Emperor",
    keywords: ["Структура", "Порядок", "Контроль"],
    symbolism: [
      "Мужчина в доспехах на троне с бараньими головами",
      "Скипетр и держава",
      "Красная одежда, скалистый фон"
    ],
    symbolismInterpretation:
      "Олицетворяет власть, закон, порядок, формирование границ и структуры",
    archetype: "Отец, правитель, архетип власти и устойчивости",
    psychology: "Умение брать ответственность, стремление к контролю",
    upright: {
      personality: "Решительность, сила, авторитет",
      relationships: "Стабильность, защита, поддержка",
      work: "Лидерство, организация, управление",
      spirituality: "Дисциплина, самообладание",
      examples: ["Установление порядка", "Планомерное достижение цели", "Контроль над ситуацией"]
    },
    reversed: {
      meaning: "Жёсткость, деспотизм, упрямство",
      nuances: "Потеря гибкости, подавление"
    },
    associations: ["Власть", "Закон", "Защита", "Структура"],
    combinations: [
      "С Императрицей — стабильный союз, структура и забота",
      "С Дьяволом — авторитаризм"
    ],
    readingTips: ["Разделять лидерство и давление", "Не подменять силу подавлением"],
    selfQuestions: ["Где мне важно проявить силу?", "Не мешает ли контроль естественному течению?"]
  };


